import { AppState } from '../../../../../../app/app.global';
import { Component } from '@angular/core';
import { NavController,AlertController } from 'ionic-angular';
import { VerifyByPhoneMainPage } from '../main/byphonemain'
@Component({
  selector: 'login-children-page',
  templateUrl: 'byphonefirst.html'
})
export class VerifyByPhoneFirstPage {

  telephone:string="";
  constructor(public navCtrl: NavController,public global: AppState,private alertCtrl: AlertController) {
      
  }
  toVerifyByPhoneMain(){
  	if(this.telephone == ""){
  		let alert = this.alertCtrl.create({
        subTitle: '请输入手机号!',
        buttons: ['确定']
      });
      alert.present();
  	}else{
  		this.navCtrl.push(VerifyByPhoneMainPage, {"telephone":this.telephone});
  	}
  	
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/password/types/byphone/first/byphonefirst.ts